import { EntityData, WordBoxData } from '../types';

export interface CustomLevel {
  name: string;
  description: string;
  author: string;
  version: string;
  difficulty: 'easy' | 'medium' | 'hard';
  tags: string[];
  created: string;
  entities: EntityData[];
  wordBoxes: { [dimension: number]: WordBoxData[] };
}

export interface EditorState {
  currentDimension: number;
  selectedTool: 'entity' | 'word' | 'erase' | 'select';
  selectedEntity?: string;
  selectedWord?: string;
  level: CustomLevel;
  history: EditorAction[];
  historyIndex: number;
  isDirty: boolean;
  isValidating: boolean;
  validation?: ValidationResult;
}

export interface EditorAction {
  type: 'ADD_ENTITY' | 'REMOVE_ENTITY' | 'MOVE_ENTITY' | 'ADD_WORD' | 'REMOVE_WORD' | 'MOVE_WORD';
  data: any;
  timestamp: number;
}

export interface ValidationResult {
  valid: boolean;
  errors: string[];
  warnings: string[];
  info: string[];
}

export const GRID_WIDTH = 20;
export const GRID_HEIGHT = 12;
export const CELL_SIZE = 64;
export const MAX_ENTITIES = 100;
export const MAX_HISTORY = 50;

export const ENTITY_TYPES = [
  'PHANTOM',
  'PORTAL',
  'BARRIER',
  'ORB',
  'CRYSTAL',
  'ROCK',
  'WATER',
  'FIRE',
  'KEY',
  'DOOR',
  // Advanced entities
  'ICE',
  'LAVA',
  'MIRROR',
  'VOID',
  'BOLT',
  'STAR',
  'SKULL',
  'COIN',
  'GHOST',
  'STATUE',
  // Enemy entities
  'HUNTER',
  'WATCHER',
  'SHADOW',
  'PURSUER',
  'SENTINEL'
] as const;

export const WORD_NOUNS = [
  'WORD_PHANTOM',
  'WORD_PORTAL',
  'WORD_BARRIER',
  'WORD_ORB',
  'WORD_CRYSTAL',
  'WORD_ROCK',
  'WORD_WATER',
  'WORD_FIRE',
  'WORD_KEY',
  'WORD_DOOR',
  // Advanced nouns
  'WORD_ICE',
  'WORD_LAVA',
  'WORD_MIRROR',
  'WORD_VOID',
  'WORD_BOLT',
  'WORD_STAR',
  'WORD_SKULL',
  'WORD_COIN',
  'WORD_GHOST',
  'WORD_STATUE',
  // Enemy nouns
  'WORD_HUNTER',
  'WORD_WATCHER',
  'WORD_SHADOW',
  'WORD_PURSUER',
  'WORD_SENTINEL'
] as const;

export const WORD_PROPERTIES = [
  'WORD_YOU',
  'WORD_WIN',
  'WORD_STOP',
  'WORD_PUSH',
  'WORD_PHASE',
  'WORD_SINK',
  'WORD_HOT',
  'WORD_MELT',
  'WORD_OPEN',
  'WORD_SHUT',
  'WORD_MOVE',
  'WORD_DEFEAT',
  'WORD_TRANSFORM',
  // Advanced properties
  'WORD_FLOAT',
  'WORD_SLIP',
  'WORD_TELE',
  'WORD_CLONE',
  'WORD_SWAP',
  'WORD_WEAK',
  'WORD_STRONG',
  'WORD_PULL',
  'WORD_FALL',
  'WORD_REVERSE',
  // Enemy properties
  'WORD_HUNT',
  'WORD_TRACK',
  'WORD_MIMIC',
  'WORD_GUARD',
  'WORD_ALERT'
] as const;

export const WORD_CONNECTOR = 'WORD_IS';

export const DIMENSION_COLORS = {
  1: '#FFFFFF',
  2: '#00FFFF',
  3: '#FF00FF',
  4: '#00FF00'
};
